<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 90 90"
  >
    <defs>
      <linearGradient
        id="prefix__a"
        x1="50%"
        x2="104.507%"
        y1="0%"
        y2="57.362%"
      >
        <stop offset="0%" stop-color="#9CAFEE" />
        <stop offset="100%" stop-color="#C4D1F4" />
      </linearGradient>
      <linearGradient
        id="prefix__b"
        x1="-13.488%"
        x2="68.017%"
        y1="120.836%"
        y2="31.979%"
      >
        <stop offset="0%" stop-color="#91A5E5" />
        <stop offset="100%" stop-color="#CCD9FA" />
      </linearGradient>
      <linearGradient
        id="prefix__e"
        x1="25.316%"
        x2="50%"
        y1="28%"
        y2="58.475%"
      >
        <stop offset="0%" stop-color="#EFF3FF" />
        <stop offset="100%" stop-color="#DAE2FF" />
      </linearGradient>
      <linearGradient
        id="prefix__h"
        x1="21.309%"
        x2="66.264%"
        y1="72.355%"
        y2="50%"
      >
        <stop offset="0%" stop-color="#D1D9F4" />
        <stop offset="100%" stop-color="#DAE2FF" />
      </linearGradient>
      <path id="prefix__c" d="M7.207 10l-7 10 23 14 7-11z" />
      <path id="prefix__f" d="M37.207 10l-7 10 20 14 7-11z" />
      <path
        id="prefix__i"
        d="M24.998.088L25 0c0 .553-.141 1.245-.424 2.075-.424 1.246.424 2.906-2.546 4.982-1.88 1.314-5.292 1.255-10.235-.177 2.159-.291 4.575-1.115 7.25-2.47 2.495-1.264 4.48-2.705 5.953-4.322zm-1.11.534c-1.332 1.25-3.007 2.389-5.028 3.413-2.817 1.427-5.333 2.253-7.547 2.48L11 6.643c1.414-.554 2.404-1.107 2.97-1.66.848-.831.424-2.491 3.818-3.737 3.394-1.245 4.242 0 5.515-.415.17-.055.328-.11.475-.166z"
      />
      <path
        id="prefix__j"
        d="M1 8c.88.243 1.546.576 2 1 1.058.987 2.189 3 3 3 2 0-3 2-5 0-1.333-1.333-1.333-2.667 0-4z"
      />
      <filter
        id="prefix__d"
        width="130%"
        height="141.7%"
        x="-8.3%"
        y="-10.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx="2" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.534935128 0 0 0 0 0.61133141 0 0 0 0 0.850069792 0 0 0 0.281828767 0"
        />
      </filter>
      <filter
        id="prefix__g"
        width="133.3%"
        height="141.7%"
        x="-9.3%"
        y="-10.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dx="2" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.534935128 0 0 0 0 0.61133141 0 0 0 0 0.850069792 0 0 0 0.281828767 0"
        />
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <circle cx="45" cy="45" r="45" fill="#F4F5FF" />
      <path
        fill="url(#prefix__a)"
        d="M7.207 10l21 14V0z"
        transform="translate(16 27)"
      />
      <path
        fill="url(#prefix__b)"
        transform="matrix(-1 0 0 1 94.207 27)"
        d="M28 10l22 21 .207-31z"
      />
      <path fill="#DAE2FF" d="M23.207 62.946V37l23 13.054V76z" />
      <path fill="#C3D0F8" d="M66.207 64.027V37l-20 13.054V76z" />
      <g transform="rotate(-1 1570.154 -881.21)">
        <use xlink:href="#prefix__c" fill="#000" filter="url(#prefix__d)" />
        <use xlink:href="#prefix__c" fill="url(#prefix__e)" />
      </g>
      <g transform="scale(-1 1) rotate(-1 1538.947 5960.552)">
        <use xlink:href="#prefix__f" fill="#000" filter="url(#prefix__g)" />
        <use xlink:href="#prefix__f" fill="url(#prefix__h)" />
      </g>
      <g transform="translate(32.207 14)">
        <use xlink:href="#prefix__i" fill="#D7DFFC" />
        <use xlink:href="#prefix__i" fill="#C7E099" />
        <use xlink:href="#prefix__j" fill="#D8E0FD" />
        <use xlink:href="#prefix__j" fill="#CBE2A0" />
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
import { useId, useNamespace } from '@element-plus/hooks'

defineOptions({
  name: 'ImgEmpty',
})

const ns = useNamespace('empty')
const id = useId()
</script>
